import styles from "./styles.scss";
import {SubtitleWireframe, BodyWireframe} from "../TypographyWireframes/TypographyWireframes";

export const Heading = ({ children, style, className, size = "h6" }) => (
  <h6 style={style} className={[styles[size], className].join(" ")}>
    {children}
  </h6>
);

export const Subtitle = ({ children, style, color, className, size = "subtitle1", weight = "initial", loading = false, wireframeWidth = 200}) => loading ? (<SubtitleWireframe style={style} size={size} width={wireframeWidth} />) : (
  <p style={{
    color,
    ...style,
    fontWeight: weight
  }} className={[styles[size], className].join(" ")}>{children}</p>
);

export const Body = ({ children, style, color, center, dangerouslySetInnerHTML, className, size = "body1", weight = "initial", loading = false, wireframeWidth = 200 }) => loading ? <BodyWireframe style={style} size={size} width={wireframeWidth} /> : (
  <p
    className={[styles[size], className].join(" ")}
    style={{
      ...style,
      color: color,
      fontWeight: weight,
      textAlign: center ? "center" : "initial"
    }}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
  >
    {children}
  </p>
);



// WEBPACK FOOTER //
// ./components/typography/index.js